// extracted by mini-css-extract-plugin
module.exports = {"cashIcon":"styles_cashIcon__CQeeY"};